
       <!-- Default box -->
       <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Invoice List</div> 
         <div class="row mt-2 pl-1">
           <div class="input-group col-md-5">   
            <div class="col">
              <div class="input-group">
                  <span class="input-group-prepend">
                      <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
                  </span>
                  <input [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border-left-0  border-right-0 border" type="text" placeholder="Search">
                  <span class="input-group-append">
                    <button class="btn  border-left-0 border" type="button">
                        <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                    </button>
                  </span>            
              </div>  
              
            </div>                 
          </div>
          <div class="col-md-4">
            <mat-radio-group (change)="checkedChangeRdoButtons($event)">  
              <mat-radio-button class="m-2" checked value="All" >All</mat-radio-button>
              <mat-radio-button class="m-2" value="Paid" >Paid</mat-radio-button>
              <mat-radio-button class="m-2" value="Unpaid">Unpaid</mat-radio-button>
            </mat-radio-group>
          </div>
           <div class="col-md-3">
             <button *ngIf="crud_access.create"  class="btn btn-success float-right mr-4 " (click)="newButtonClick()"><i class="fa fa-plus p-1"></i>New Invoice</button>
           </div>      
         </div>
      
         <fieldset>
         <div class="card-body">

          <div>
          <mat-table [dataSource]="dataSource" matSort>
           

            <ng-container matColumnDef="invoiceNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Invoice No. </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.InvoiceNo}} </mat-cell>
            </ng-container>
                     
            <ng-container matColumnDef="invoiceDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Invoice Date </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.InvoiceDate | date :'y-MM-dd'}} </mat-cell>
            </ng-container>
                    
            <ng-container matColumnDef="customer">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> GuestName </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.GuestName}} </mat-cell>
            </ng-container>
                   
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> Amount </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> {{element.GrandTotal |  number:'1.2-2'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paid">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> Paid </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }">  {{ (convertToFloat(element.AmountPaid) + convertToFloat(element.AdvancePaid)) | number:'1.2-2' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="due">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }">Due</mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-right" [ngClass]="{'dark-bg' : isDark }"> {{element.BalToPay |  number:'1.2-2'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-center" [ngClass]="{'dark-bg' : isDark }"> Status </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-center" [ngClass]="{'dark-bg' : isDark }"><span class="badge" [ngClass]="{'badge-warning' : element.Status==='Unpaid', 'badge-success' : element.Status==='Paid','badge-info' : element.Status==='Partially paid','badge-danger' : element.Status==='Cancelled' }" >{{element.Status }}</span></mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef  mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
              <mat-cell *matCellDef="let element"    [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
              <mat-cell *matCellDef="let row" [ngClass]="{'dark-bg' : isDark }">
                <button *ngIf="crud_access.read"  class="btn btn-primary btn-sm  text-white"  (click)="viewDetailsButtonClick(row.InvoiceNo)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="fa fa-pencil-square"></i></button>  
                <button  [disabled]="!crud_access.createReceipt || row.BalToPay==0"   class="btn btn-success btn-sm ml-1 text-white"  (click)="payButtonClicked(row.InvoiceNo)" data-toggle="deleteTooltip" data-placement="bottom" title="Pay"><i class="fa fa-sign-out-alt"></i></button>       
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="loading">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
            </ng-container>

            <ng-container matColumnDef="noData">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
            <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
          </mat-table>

          <mat-paginator [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          </div>
          
         </div>                                
         <!-- /.card-body -->

       </fieldset>

       </div>
 
     
   <script>
   
     $(function () {
     $('[data-toggle="viewTooltip"]').tooltip()
   })
   $(function () {
     $('[data-toggle="deleteTooltip"]').tooltip()
   })
   </script>


